package fr.frux.core.network.api

import dev.zacsweers.metro.ContributesBinding
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.SingleIn
import fr.frux.core.common.di.AppScope
import fr.frux.core.network.ApiPaths
import fr.frux.shared.dto.ClusterPyramidDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.plugins.RedirectResponseException
import io.ktor.client.request.get
import io.ktor.client.request.header
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode
import io.ktor.http.etag

/**
 * Resultat d'un chargement de la pyramide : soit son contenu avec l'ETag servi par le backend,
 * soit la confirmation que l'ETag rejoue est toujours valide (304, corps epargne).
 */
sealed interface ClusterPyramidFetch {
    data class Fetched(
        val pyramid: ClusterPyramidDto,
        val etag: String?,
    ) : ClusterPyramidFetch

    data object NotModified : ClusterPyramidFetch
}

/**
 * Pyramide de regroupements precalculee par le serveur (#622, ADR 0039). Interface distincte de
 * `TreeApi` : le chargement est conditionnel et sans rapport avec les lectures geographiques.
 */
interface TreeClustersApi {
    suspend fun getClusterPyramid(etag: String? = null): ClusterPyramidFetch
}

@ContributesBinding(AppScope::class)
@SingleIn(AppScope::class)
@Inject
class TreeClustersApiImpl(
    private val httpClient: HttpClient,
) : TreeClustersApi {
    override suspend fun getClusterPyramid(etag: String?): ClusterPyramidFetch =
        try {
            val response =
                httpClient.get("${ApiPaths.V1}/trees/clusters") {
                    etag?.let { header(HttpHeaders.IfNoneMatch, it) }
                }
            ClusterPyramidFetch.Fetched(response.body<ClusterPyramidDto>(), response.etag())
        } catch (e: RedirectResponseException) {
            // expectSuccess = true traite tout 3xx en erreur : le 304 attendu ici est le seul cas
            // legitime, et seulement si nous avons vraiment rejoue un ETag.
            if (etag != null && e.response.status == HttpStatusCode.NotModified) {
                ClusterPyramidFetch.NotModified
            } else {
                throw e
            }
        }
}
